export var lbl = [];

lbl["fr.0"] = "Catégorie article";
lbl["fr.1"] = "Clientelle";
lbl["fr.2"] = "Quantité : ";
lbl["fr.3"] = "Vente : ";
lbl["fr.4"] = "Promo : ";
lbl["fr.5"] = "Du ";
lbl["fr.6"] = "Au ";
lbl["fr.7"] = "Achat : ";
lbl["fr.8"] = "> Montre Menu Magasin";
lbl["fr.9"] = "v Cache Menu Magasin";

/* AR */

lbl["ar.0"] = "نوع السلعة";
lbl["ar.1"] = "الزبون";
lbl["ar.2"] = "كمية : ";
lbl["ar.3"] = "بيع : ";
lbl["ar.4"] = "تخفيض : ";
lbl["ar.5"] = "من ";
lbl["ar.6"] = "إلى ";
lbl["ar.7"] = "شراء : ";
lbl["ar.8"] = "أظهر قائمة المحل <";
lbl["ar.9"] = "اخف قائمة المحل v";

/* EN */

lbl["en.0"] = "Item Category";
lbl["en.1"] = "Clientele";
lbl["en.2"] = "Amount : ";
lbl["en.3"] = "Sale : ";
lbl["en.4"] = "Promo : ";
lbl["en.5"] = "From ";
lbl["en.6"] = "To ";
lbl["en.7"] = "Buying : ";
lbl["en.8"] = "> Show Shop Menu";
lbl["en.9"] = "v Hide Shop Menu";

/* DE */

lbl["de.0"] = "Artikelkategorie";
lbl["de.1"] = "Kunden";
lbl["de.2"] = "Menge : ";
lbl["de.3"] = "Verkauf : ";
lbl["de.4"] = "Promo : ";
lbl["de.5"] = "ab ";
lbl["de.6"] = "bis ";
lbl["de.7"] = "Kauf : ";
lbl["de.8"] = "> Showen Agence Menu";
lbl["de.9"] = "v Hidden Agence Menu";
